import ShipmentsConfigurations from '@/pages/Products/Shipments'
import { Logout } from '@/components/log-out'
import { Screen404 } from '@/pages/404/404'
import CreateProducts from '@/pages/CreateProducts/CreateProducts'
import Dashboard from '@/pages/Dashboard/Dashboard'
import Affiliate from '@/pages/EditProduct/Affiliate/Affiliate'
import Partners from '@/pages/EditProduct/Partners/Partners'
import PublicMarketplace from '@/pages/EditProduct/PublicMarketplace/PublicMarketplace'
import Checkouts from '@/pages/EditProduct/Checkouts/Checkouts'
import PersonalizeCheckout from '@/pages/EditProduct/Checkouts/PersonalizeCheckout/PersonalizeCheckout'
import Coproductor from '@/pages/EditProduct/Coproductor/Coproductor'
import { CuponsPage } from '@/pages/EditProduct/Cupons/Cupons'
import EditLayout from '@/pages/EditProduct/EditLayout'
import EditProduct from '@/pages/EditProduct/EditProduct'
import FunnelMap from '@/pages/EditProduct/FunnelMap/FunnelMap';
import Links from '@/pages/EditProduct/Links';
import Offers from '@/pages/EditProduct/Offers/Offers';
import Orderbumps from '@/pages/EditProduct/Orderbumps/Orderbumps';
import Pixels from '@/pages/EditProduct/Pixels/Pixels.tsx';
import CreateUpsell from '@/pages/EditProduct/Upsells/Partials/CreateUpsell';
import Upsells from '@/pages/EditProduct/Upsells/Upsells';
import Financial from '@/pages/Financial/Financial';
import ImpToken from '@/pages/ImpToken/ImpToken';
import ActiveCampaign from '@/pages/Integrations/ActiveCampaign';
import AppSell from '@/pages/Integrations/AppSell';
import AstronMembers from '@/pages/Integrations/AstronMembers/AstronMembers';
import BotConversa from '@/pages/Integrations/BotConversa/BotConversa';
import Configurations from '@/pages/Integrations/Configurations/configurations';
import EagleLabs from '@/pages/Integrations/EagleLabs';
import Jetpack from '@/pages/Integrations/Jetpack';
import Hotzapp from '@/pages/Integrations/Hotzapp/Hotzapp';
import Integrations from '@/pages/Integrations/Integrations';
import Cademi from '@/pages/Integrations/Cademi/Cademi';
import Memberkit from '@/pages/Integrations/Memberkit/Memberkit';
import SmsFunnel from '@/pages/Integrations/SmsFunnel/SmsFunnel';
import Tb3 from '@/pages/Integrations/Tb3';
import UTMify from '@/pages/Integrations/UTMify/UTMify';
import Vturb from '@/pages/Integrations/Vturb/Vturb';
import Webhook from '@/pages/Integrations/Webhook/Webhook';
import WebhooksHistory from '@/pages/Integrations/webhooks-history';
import Developers from '@/pages/Integrations/Developers/developers';
import Xtracky from '@/pages/Integrations/XTracky/Xtracky';
import Tauk from '@/pages/Integrations/Tauk';
import { InvitationAffiliateConfirm } from '@/pages/InvitationAffiliateConfirm/InvitationAffiliateConfirm';
import { InvitationAffiliateLink } from '@/pages/InvitationAffiliateLink/InvitationAffiliateLink';
import { InvitationPartnerConfirm } from '@/pages/InvitationPartnerConfirm/InvitationPartnerConfirm';
import { InvitationPartnerLink } from '@/pages/InvitationPartnerLink/InvitationPartnerLink';
import { InvitationAcceptInvite } from '@/pages/InvitationAcceptInvite/InvitationAcceptInvite';
import { InvitationAcceptConfirm } from '@/pages/InvitationAcceptInvite/InvitationAcceptConfirm';
import Marketplace from '@/pages/Marketplace/marketplace';
import MarketingDetailsPage from '@/pages/Marketplace/MarketplaceDetails/marketplace-details';
import MyAccount from '@/pages/MyAccount/MyAccount';
import Onboarding from '@/pages/Onboarding/Onboarding';
import Orders from '@/pages/Orders/Orders';
import Disputes from '@/pages/Disputes/Disputes';
import Products from '@/pages/Products';
import ReferAndEarn from '@/pages/ReferAndEarn/ReferAndEarn';
import Reports from '@/pages/Reports';
import Analytics from '@/pages/Reports/Analytics';
import CartAbandonment from '@/pages/Reports/CartAbandonment';
import FinancialAudit from '@/pages/Reports/FinancialAudit';
import PartnerCommissions from '@/pages/Reports/PartnerCommissions';
import SalesByStatus from '@/pages/Reports/SalesByStatus/SalesByStatus';
import UTMPanel from '@/pages/Reports/UTMPanel';
import GlobalAffiliateReport from '@/pages/Reports/GlobalAffiliateReport';
import Sales from '@/pages/Sales/Sales';
import SalesDetails from '@/pages/Sales/SalesDetails/SalesDetails';
import SentryExamplePage from '@/pages/SentryExamplePage';
import Signatures from '@/pages/Signatures/Signatures';
import SubscriptionDetails from '@/pages/Signatures/SubscriptionDetails/SubscriptionDetails';
import VerificatedEmail from '@/pages/VerificatedEmail/VerificatedEmail';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { PostLoginRedirect } from '@/auth/PostLoginRedirect';
import { isMarketplaceEnabled } from '@/utils/isMarketplaceEnabled';
import Notazz from "@/pages/Integrations/Notazz/Notazz";
import EnotasPage from "@/pages/Integrations/Enotas/Enotas";
import Team from '@/pages/Team/Team';
import StorePickerPage from '@/pages/StoreSelector/StorePickerPage';
import HelpGrid from '@/pages/Integrations/HelpGrid';
import ShipOffers from '@/pages/Integrations/ShipOffers';
import RedRock from '@/pages/Integrations/RedRock';
import { RequireOnboardingFinished } from '@/auth/RequireOnboardingFinished';
import { RequireContractSigned } from '@/auth/RequireContractSigned';
import { RequirePermission } from '@/auth/RequirePermission';
import Contract from '@/pages/Contract/Contract';

function InsideRootLayout() {
  return (
    <>
      <PostLoginRedirect />
      <Outlet />
    </>
  );
}

export default function InsideRoutes() {
  const router = createBrowserRouter([
    {
      element: <InsideRootLayout />,
      children: [
        // Public / meta
        { path: '/', element: <Dashboard /> },
        { path: '/dashboard', element: <Dashboard /> },
        { path: '/onboarding', element: <Onboarding /> },
        { path: '/contract', element: <Contract /> },
        { path: '/by-imp', element: <ImpToken /> },
        {
          path: '/products/shipments',
          element: (
            <RequirePermission
              anyOf={['shipping.view_shipping_configurations']}
            >
              <RequireContractSigned>
                <ShipmentsConfigurations />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        { path: '/select-store', element: <StorePickerPage /> },
        { path: '/email-verified', element: <VerificatedEmail /> },
        { path: '/sentry-example-page', element: <SentryExamplePage /> },
        { path: '/logout', element: <Logout /> },

        // Marketplace
        ...(isMarketplaceEnabled
          ? ([
              {
                path: '/marketplace',
                element: (
                  <RequirePermission anyOf={['marketplace.view_marketplace']}>
                    <Marketplace />
                  </RequirePermission>
                ),
              },
              {
                path: '/marketplace/:id',
                element: (
                  <RequirePermission anyOf={['marketplace.view_marketplace']}>
                    <MarketingDetailsPage />
                  </RequirePermission>
                ),
              },
            ] as const)
          : []),

        // Products
        {
          path: '/products',
          element: (
            <RequirePermission
              anyOf={[
                'products.view_products',
                'products.view_products_by_role',
              ]}
            >
              <RequireContractSigned>
                <Products />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/products/create-products',
          element: (
            <RequirePermission anyOf={['products.create_product']}>
              <RequireContractSigned>
                <CreateProducts />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/products/edit-product/:id/checkouts/:checkoutId',
          element: (
            <RequirePermission anyOf={['checkouts.customize_checkout']}>
              <RequireContractSigned>
                <PersonalizeCheckout />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/products/edit-product/:id/upsells/create',
          element: (
            <RequirePermission anyOf={['upsells.create_upsell']}>
              <RequireContractSigned>
                <CreateUpsell />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/products/edit-product/:id/funnel',
          element: (
            <RequireContractSigned>
              <FunnelMap />
            </RequireContractSigned>
          ),
        },
        {
          path: '/products/edit-product/:id',
          element: (
            <RequirePermission
              anyOf={[
                'products.view_products',
                'products.view_products_by_role',
              ]}
            >
              <RequireContractSigned>
                <EditLayout />
              </RequireContractSigned>
            </RequirePermission>
          ),
          children: [
            {
              path: 'geral',
              element: (
                <RequirePermission
                  anyOf={['products_edit.view_product_details']}
                >
                  <EditProduct />
                </RequirePermission>
              ),
            },
            {
              path: 'offers',
              element: (
                <RequirePermission anyOf={['offers.view_offers']}>
                  <Offers />
                </RequirePermission>
              ),
            },
            {
              path: 'upsells',
              element: (
                <RequirePermission anyOf={['upsells.view_upsells']}>
                  <Upsells />
                </RequirePermission>
              ),
            },
            {
              path: 'affiliate',
              element: (
                <RequirePermission anyOf={['affiliates.view_affiliates']}>
                  <Affiliate />
                </RequirePermission>
              ),
            },
            {
              path: 'public-marketplace',
              element: (
                <RequirePermission
                  anyOf={['products_edit.view_product_details']}
                >
                  <PublicMarketplace />
                </RequirePermission>
              ),
            },
            {
              path: 'partners',
              element: (
                <RequirePermission
                  anyOf={[
                    'partner_indications.configure_partner_program',
                    'partner_indications.view_partner_indications',
                    'partner_indications.manage_partners',
                  ]}
                >
                  <Partners />
                </RequirePermission>
              ),
            },
            {
              path: 'checkouts',
              element: (
                <RequirePermission anyOf={['checkouts.view_checkouts']}>
                  <Checkouts />
                </RequirePermission>
              ),
            },
            {
              path: 'order-bumps',
              element: (
                <RequirePermission anyOf={['order_bumps.view_order_bumps']}>
                  <Orderbumps />
                </RequirePermission>
              ),
            },
            {
              path: 'pixels',
              element: (
                <RequirePermission anyOf={['pixels.view_pixels']}>
                  <Pixels />
                </RequirePermission>
              ),
            },
            {
              path: 'coproductor',
              element: (
                <RequirePermission anyOf={['coproducers.view_coproducers']}>
                  <Coproductor />
                </RequirePermission>
              ),
            },
            { path: 'coupons', element: <CuponsPage /> },
            {
              path: 'links',
              element: (
                <RequirePermission anyOf={['links.view_links']}>
                  <Links />
                </RequirePermission>
              ),
            },
          ],
        },

        // Integrations
        {
          path: '/integrations',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <RequireContractSigned>
                <Integrations />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/integrations/configurations',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Configurations />
            </RequirePermission>
          ),
        },
        {
          path: '/integrations/webhooks-history',
          element: (
            <RequirePermission anyOf={['integrations.view_webhook_history']}>
              <WebhooksHistory />
            </RequirePermission>
          ),
        },
        {
          path: '/integrations/developers',
          element: (
            <RequirePermission anyOf={['integrations.manage_api_keys']}>
              <Developers />
            </RequirePermission>
          ),
        },
        {
          path: '/integrations',
          children: [
            {
              path: 'webhook',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Webhook />
                </RequirePermission>
              ),
            },
            {
              path: 'xtracky',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Xtracky />
                </RequirePermission>
              ),
            },
            {
              path: 'utmify',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <UTMify />
                </RequirePermission>
              ),
            },
            {
              path: 'hotzapp',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Hotzapp />
                </RequirePermission>
              ),
            },
            {
              path: 'memberkit',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Memberkit />
                </RequirePermission>
              ),
            },
            {
              path: 'cademi',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Cademi />
                </RequirePermission>
              ),
            },
            {
              path: 'sms_funnel',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <SmsFunnel />
                </RequirePermission>
              ),
            },
            {
              path: 'bot_conversa',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <BotConversa />
                </RequirePermission>
              ),
            },
            {
              path: 'eagle_labs',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <EagleLabs />
                </RequirePermission>
              ),
            },
            {
              path: 'jetpack',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Jetpack />
                </RequirePermission>
              ),
            },
            {
              path: 'ship-offers',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <ShipOffers />
                </RequirePermission>
              ),
            },
            {
              path: 'red_rock',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <RedRock />
                </RequirePermission>
              ),
            },
            {
              path: 'app_sell',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <AppSell />
                </RequirePermission>
              ),
            },
            {
              path: 'tb3',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Tb3 />
                </RequirePermission>
              ),
            },
            {
              path: 'astron_members',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <AstronMembers />
                </RequirePermission>
              ),
            },
            {
              path: 'active_campaign',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <ActiveCampaign />
                </RequirePermission>
              ),
            },
            {
              path: 'vturb',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Vturb />
                </RequirePermission>
              ),
            },
            {
              path: 'notazz',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Notazz />
                </RequirePermission>
              ),
            },
            {
              path: 'enotas',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <EnotasPage />
                </RequirePermission>
              ),
            },
            {
              path: 'tauk',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <Tauk />
                </RequirePermission>
              ),
            },
            {
              path: 'helpgrid',
              element: (
                <RequirePermission anyOf={['integrations.view_integrations']}>
                  <HelpGrid />
                </RequirePermission>
              ),
            },
          ],
        },

        // Account
        {
          path: '/my-account',
          element: (
            <RequirePermission
              anyOf={[
                'account.view_profile_identity',
                'account.view_address',
                'account.view_notification_settings',
              ]}
            >
              <RequireOnboardingFinished>
                <MyAccount />
              </RequireOnboardingFinished>
            </RequirePermission>
          ),
        },
        {
          path: '/team',
          element: (
            <RequirePermission anyOf={['team.manage_team']}>
              <RequireOnboardingFinished>
                <Team />
              </RequireOnboardingFinished>
            </RequirePermission>
          ),
        },

        // Financial
        {
          path: '/financial',
          element: (
            <RequirePermission
              anyOf={[
                'wallet.view_available_balance',
                'wallet.view_balance_to_release',
                'wallet.view_retention_balance',
                'wallet.view_total_withdrawn',
                'financial.view_withdrawals_list',
                'financial.view_account_statement',
                'financial.view_balance_forecast',
                'financial.view_transactions',
                'financial.view_fees_and_terms',
              ]}
            >
              <RequireContractSigned>
                <Financial />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },

        // Sales
        {
          path: '/sales',
          element: (
            <RequirePermission
              anyOf={[
                'metrics.view_sale_data',
                'order_details.view_order_details',
              ]}
            >
              <RequireContractSigned>
                <Sales />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/sales/orders',
          element: (
            <RequirePermission anyOf={['orders.view_orders_list']}>
              <RequireContractSigned>
                <Orders />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/sales/disputes',
          element: (
            <RequirePermission anyOf={['disputes.view_disputes']}>
              <RequireContractSigned>
                <Disputes />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/sales/sales-details/:id',
          element: (
            <RequirePermission anyOf={['order_details.view_order_details']}>
              <RequireContractSigned>
                <SalesDetails />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },

        // Signatures
        {
          path: '/signatures',
          element: (
            <RequireContractSigned>
              <Signatures />
            </RequireContractSigned>
          ),
        },
        {
          path: '/signatures/signatures-details/:id',
          element: (
            <RequireContractSigned>
              <SubscriptionDetails />
            </RequireContractSigned>
          ),
        },

        // Reports
        {
          path: '/reports',
          element: (
            <RequirePermission
              anyOf={[
                'reports.view_cart_abandonment',
                'reports.view_financial_analysis',
                'reports.view_utm_panel',
                'reports.view_analytics',
                'partner_indications.view_partner_commissions',
              ]}
            >
              <RequireContractSigned>
                <Reports />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/reports/cart-abandonment',
          element: (
            <RequirePermission anyOf={['reports.view_cart_abandonment']}>
              <RequireContractSigned>
                <CartAbandonment />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/reports/analytics',
          element: (
            <RequirePermission anyOf={['reports.view_analytics']}>
              <RequireContractSigned>
                <Analytics />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/reports/financial-audit',
          element: (
            <RequirePermission anyOf={['reports.view_financial_analysis']}>
              <RequireContractSigned>
                <FinancialAudit />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/reports/utm-panel',
          element: (
            <RequirePermission anyOf={['reports.view_utm_panel']}>
              <RequireContractSigned>
                <UTMPanel />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/reports/status_sale',
          element: (
            <RequirePermission anyOf={['metrics.view_sale_data']}>
              <RequireContractSigned>
                <SalesByStatus />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },
        {
          path: '/reports/partner-commissions',
          element: (
            <RequirePermission
              anyOf={['partner_indications.view_partner_commissions']}
            >
              <RequireContractSigned>
                <PartnerCommissions />
              </RequireContractSigned>
            </RequirePermission>
          ),
        },

        // Refer & Earn
        {
          path: '/refer-and-earn',
          element: (
            <RequirePermission
              anyOf={[
                'referral.view_referral_program',
                'referral.view_referral_link',
              ]}
            >
              <ReferAndEarn />
            </RequirePermission>
          ),
        },

        // Invitations
        {
          path: '/invitation-affiliate/:productId',
          element: <InvitationAffiliateLink />,
        },
        {
          path: '/invitation-affiliate-confirm',
          element: <InvitationAffiliateConfirm />,
        },
        {
          path: '/invitation-partner/:productId',
          element: <InvitationPartnerLink />,
        },
        {
          path: '/invitation-partner-confirm',
          element: <InvitationPartnerConfirm />,
        },
        {
          path: '/invitation-accept/:token',
          element: <InvitationAcceptInvite />,
        },
        {
          path: '/invitation-accept-confirm',
          element: <InvitationAcceptConfirm />,
        },

        // Fallback
        { path: '*', element: <Screen404 /> },
      ],
    },

    // Integrations
    {
      path: '/integrations',
      element: (
        <RequirePermission anyOf={['integrations.view_integrations']}>
          <RequireContractSigned>
            <Integrations />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/integrations/configurations',
      element: (
        <RequirePermission anyOf={['integrations.view_integrations']}>
          <Configurations />
        </RequirePermission>
      ),
    },
    {
      path: '/integrations/webhooks-history',
      element: (
        <RequirePermission anyOf={['integrations.view_webhook_history']}>
          <WebhooksHistory />
        </RequirePermission>
      ),
    },
    {
      path: '/integrations/developers',
      element: (
        <RequirePermission anyOf={['integrations.manage_api_keys']}>
          <Developers />
        </RequirePermission>
      ),
    },
    {
      path: '/integrations',
      children: [
        {
          path: 'webhook',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Webhook />
            </RequirePermission>
          ),
        },
        {
          path: 'xtracky',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Xtracky />
            </RequirePermission>
          ),
        },
        {
          path: 'utmify',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <UTMify />
            </RequirePermission>
          ),
        },
        {
          path: 'hotzapp',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Hotzapp />
            </RequirePermission>
          ),
        },
        {
          path: 'memberkit',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Memberkit />
            </RequirePermission>
          ),
        },
        {
          path: 'cademi',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Cademi />
            </RequirePermission>
          ),
        },
        {
          path: 'sms_funnel',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <SmsFunnel />
            </RequirePermission>
          ),
        },
        {
          path: 'bot_conversa',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <BotConversa />
            </RequirePermission>
          ),
        },
        {
          path: 'eagle_labs',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <EagleLabs />
            </RequirePermission>
          ),
        },
        {
          path: 'jetpack',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Jetpack />
            </RequirePermission>
          ),
        },
        {
          path: 'ship-offers',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <ShipOffers />
            </RequirePermission>
          ),
        },
        {
          path: 'red_rock',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <RedRock />
            </RequirePermission>
          ),
        },
        {
          path: 'app_sell',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <AppSell />
            </RequirePermission>
          ),
        },
        {
          path: 'tb3',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Tb3 />
            </RequirePermission>
          ),
        },
        {
          path: 'astron_members',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <AstronMembers />
            </RequirePermission>
          ),
        },
        {
          path: 'active_campaign',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <ActiveCampaign />
            </RequirePermission>
          ),
        },
        {
          path: 'vturb',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Vturb />
            </RequirePermission>
          ),
        },
        {
          path: 'notazz',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Notazz />
            </RequirePermission>
          ),
        },
        {
          path: 'enotas',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <EnotasPage />
            </RequirePermission>
          ),
        },
        {
          path: 'tauk',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <Tauk />
            </RequirePermission>
          ),
        },
        {
          path: 'helpgrid',
          element: (
            <RequirePermission anyOf={['integrations.view_integrations']}>
              <HelpGrid />
            </RequirePermission>
          ),
        },
      ],
    },

    // Account
    {
      path: '/my-account',
      element: (
        <RequirePermission
          anyOf={[
            'account.view_profile_identity',
            'account.view_address',
            'account.view_notification_settings',
          ]}
        >
          <RequireOnboardingFinished>
            <MyAccount />
          </RequireOnboardingFinished>
        </RequirePermission>
      ),
    },
    {
      path: '/team',
      element: (
        <RequirePermission anyOf={['team.manage_team']}>
          <RequireOnboardingFinished>
            <Team />
          </RequireOnboardingFinished>
        </RequirePermission>
      ),
    },

    // Financial
    {
      path: '/financial',
      element: (
        <RequirePermission
          anyOf={[
            'wallet.view_available_balance',
            'wallet.view_balance_to_release',
            'wallet.view_retention_balance',
            'wallet.view_total_withdrawn',
            'financial.view_withdrawals_list',
            'financial.view_account_statement',
            'financial.view_balance_forecast',
            'financial.view_transactions',
            'financial.view_fees_and_terms',
          ]}
        >
          <RequireContractSigned>
            <Financial />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },

    // Sales
    {
      path: '/sales',
      element: (
        <RequirePermission anyOf={['metrics.view_sale_data', 'order_details.view_order_details']}>
          <RequireContractSigned>
            <Sales />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/sales/orders',
      element: (
        <RequirePermission anyOf={['orders.view_orders_list']}>
          <RequireContractSigned>
            <Orders />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/sales/disputes',
      element: (
        <RequirePermission anyOf={['disputes.view_disputes']}>
          <RequireContractSigned>
            <Disputes />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/sales/sales-details/:id',
      element: (
        <RequirePermission anyOf={['order_details.view_order_details']}>
          <RequireContractSigned>
            <SalesDetails />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },

    // Signatures
    {
      path: '/signatures',
      element: (
        <RequirePermission anyOf={['metrics.view_sale_data']}>
          <RequireContractSigned>
            <Signatures />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/signatures/subscriptions-details/:publicId',
      element: (
        <RequirePermission anyOf={['metrics.view_sale_data']}>
          <RequireContractSigned>
            <SubscriptionDetails />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },

    // Reports
    {
      path: '/reports',
      element: (
        <RequirePermission
          anyOf={[
            'reports.view_cart_abandonment',
            'reports.view_financial_analysis',
            'reports.view_utm_panel',
            'reports.view_analytics',
            'partner_indications.view_partner_commissions',
          ]}
        >
          <RequireContractSigned>
            <Reports />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/reports/cart-abandonment',
      element: (
        <RequirePermission anyOf={['reports.view_cart_abandonment']}>
          <RequireContractSigned>
            <CartAbandonment />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/reports/analytics',
      element: (
        <RequirePermission anyOf={['reports.view_analytics']}>
          <RequireContractSigned>
            <Analytics />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/reports/financial-audit',
      element: (
        <RequirePermission anyOf={['reports.view_financial_analysis']}>
          <RequireContractSigned>
            <FinancialAudit />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/reports/utm-panel',
      element: (
        <RequirePermission anyOf={['reports.view_utm_panel']}>
          <RequireContractSigned>
            <UTMPanel />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/reports/status_sale',
      element: (
        <RequirePermission anyOf={['metrics.view_sale_data']}>
          <RequireContractSigned>
            <SalesByStatus />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/reports/partner-commissions',
      element: (
        <RequirePermission
          anyOf={['partner_indications.view_partner_commissions']}
        >
          <RequireContractSigned>
            <PartnerCommissions />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },
    {
      path: '/reports/profit_per_affiliate',
      element: (
        <RequirePermission anyOf={['reports.view_financial_analysis']}>
          <RequireContractSigned>
            <GlobalAffiliateReport />
          </RequireContractSigned>
        </RequirePermission>
      ),
    },

    // Refer & Earn
    {
      path: '/refer-and-earn',
      element: (
        <RequirePermission anyOf={['referral.view_referral_program', 'referral.view_referral_link']}>
          <ReferAndEarn />
        </RequirePermission>
      ),
    },

    // Invitations
    {
      path: '/invitation-affiliate/:productId',
      element: <InvitationAffiliateLink />,
    },
    {
      path: '/invitation-affiliate-confirm',
      element: <InvitationAffiliateConfirm />,
    },
    {
      path: '/invitation-accept/:token',
      element: <InvitationAcceptInvite />,
    },
    {
      path: '/invitation-accept-confirm',
      element: <InvitationAcceptConfirm />,
    },

    // Fallback
    { path: '*', element: <Screen404 /> },
  ]);

  return <RouterProvider router={router} />;
}
